import { Widget, WidgetEditor } from 'jamespot-front-business';
import { WidgetsName } from 'jamespot-user-api';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/store';
import { commonComponentsRegistry } from '../../../../registry/CommonRegistry';
import { WidgetTitleEdit } from './WidgetTitleEdit';

const JRCButton = commonComponentsRegistry.getLazyComponent('Button');
const JRCModalLayout = commonComponentsRegistry.getLazyComponent('ModalLayout');
const JRCModalContent = commonComponentsRegistry.getLazyComponent('ModalContent');
const JRCIconButton = commonComponentsRegistry.getLazyComponent('IconButton');

export const CSSModalFooter = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    flex-direction: row-reverse;
`;

export const CSSWidgetHeaderEdit = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: ${(props) => props.theme.space.sm}px;
    padding: ${(props) => props.theme.space.sm}px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

export const CSSWidgetHeaderEditTitle = styled.div`
    flex: 1;
    display: flex;
    fieldset:first-of-type {
        margin: 0px !important;
    }
`;

export const CSSWidgetHeaderEditActions = styled.div`
    display: flex;
    gap: ${(props) => props.theme.space.sm}px;
`;

export const WidgetHeaderEdit = ({
    uniqid,
    name,
    handleOpenEditor,
}: {
    uniqid: string;
    name: WidgetsName;
    handleOpenEditor?: () => void;
}) => {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleOnClick = useCallback(() => {
        dispatch(
            WidgetEditor.slice.actions.registerEditor({
                uniqid,
                name,
                mode: 'edit',
            }),
        );
    }, [uniqid, dispatch, name]);

    const handleRemoveWidget = useCallback(() => {
        dispatch(Widget.slice.actions.flushWidget({ uniqid }));
    }, [uniqid, dispatch]);

    return (
        <>
            <CSSWidgetHeaderEdit>
                <CSSWidgetHeaderEditTitle>
                    <WidgetTitleEdit uniqid={uniqid} />
                </CSSWidgetHeaderEditTitle>
                <CSSWidgetHeaderEditActions>
                    <JRCIconButton
                        icon="icon-pencil"
                        bg={'grey1'}
                        bgHover={'grey2'}
                        color={'grey5'}
                        iconSize={14}
                        onClick={handleOpenEditor ?? handleOnClick}
                        title={intl.formatMessage({ id: 'BUTTON_Title_Open_Edit_Panel' })}
                    />
                    <JRCIconButton
                        icon="icon-trash"
                        bg={'grey1'}
                        bgHover={'grey2'}
                        color={'grey5'}
                        iconSize={14}
                        onClick={() => setIsOpen(true)}
                        title={intl.formatMessage({ id: 'BUTTON_Title_Open_Remove_Widget' })}
                    />
                </CSSWidgetHeaderEditActions>
            </CSSWidgetHeaderEdit>
            {isOpen && (
                <JRCModalLayout enableClickAwayCloseModal={true} open={isOpen} closeHandler={() => setIsOpen(false)}>
                    <JRCModalContent
                        overflow={'scroll'}
                        title={intl.formatMessage({ id: 'WIDGET_Remove_Widget' })}
                        onClickIconClose={() => setIsOpen(false)}>
                        {intl.formatMessage({ id: 'WIDGET_Delete_Widget_Confirmation' })}
                    </JRCModalContent>
                    <CSSModalFooter>
                        <JRCButton label={intl.formatMessage({ id: 'GLOBAL_Confirm' })} onClick={handleRemoveWidget} />
                    </CSSModalFooter>
                </JRCModalLayout>
            )}
        </>
    );
};
